import { consoleLogger } from '../logging/consoleLogger';

export const decodeBase64 = (value) => {
  try {
    return atob(value);
  } catch (err) {
    if (err instanceof DOMException && err.name === 'InvalidCharacterError') {
      consoleLogger.logError(`Value "${value}" is not valid base64`);
      throw err;
    } else {
      consoleLogger.logError(`An error occured when decoding "${value}"`);
      throw err;
    }
  }
};
